import { styled, Box, Typography } from '@mui/material'

const StyledProgress = styled(Box)`
width:100%;
position:relative;
border : 1px solid black;
background-color:white;
`
const MIN = 0
const normalise = (value: number, max: number): number => Math.min(((Math.round((value - MIN) / (max - MIN) * 10000)) / 100), 100)

export function StyledProgressBar (props: { value: number, max: number, text: string, color?: string, noCapacity?: boolean }): JSX.Element {
  const color = props.color ?? '#02AED9'
  return <StyledProgress data-testid="ProgressBar" sx={{ borderColor: color, display: 'flex', justifyContent: 'center' }}>
    <Typography sx={{ fontWeight: '600', zIndex: 2, lineHeight: 'normal', fontSize: '18px' }}>{props.text} {(props.noCapacity ?? false) ? '' : `${props.value} / ${props.max}` } </Typography>
    <div data-testid="fillBar" style={{ position: 'absolute', zIndex: 1, left: 0, height: '100%', width: `${(props.noCapacity ?? false) ? '100' : normalise(props.value, props.max)}%`, top: 0, backgroundColor: color }}></div>
  </StyledProgress>
}
